import { useEffect, useState } from "react";
import {
  IAdditional,
  IAdditionalHeaderProps,
} from "../../TableTemplate/tableTemplate";
import { toast } from "react-toastify";
import useRequest from "../../../Hooks/useRequest";
import { TableCell } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import Modal from "../../../Components/Modal/Modal";
import Button from "../../../Components/Button";
import { OrderStatus } from "../../../Interfaces/orderInterfaces";
import {
  IManualActionsTableSearchParam,
  IManualOrderTableReport,
} from "../../../Interfaces/manualInterfaces";
import SahraOrderTable from "../SahraOrder/SahraOrderTable";
import {
  cancelManualOrder,
  getManualSahraOrderTable,
  manualBulkOrderCancel,
} from "../../../Requests/manualRequests";
import SubOrdersTable from "../SubOrder/SubOrdersTable";
import ActionsTable from "../ActionsTable";
import { setManualEditRowValues } from "../../../Features/Manual/manualSlice";
import { useAppDispatch } from "../../../App/hooks";

const ManualOrderTableAdditionalHeader = ({
  onAction,
  selectedRowsIds,
  setSelectedRowsIds,
}: IAdditionalHeaderProps) => {
  const onError = (e: any) => {
    if (e.response.data.value) toast.error(e.response.data.value);
    if (e.response.status === 500) toast.error("خطا داخلی");
    else toast.error("خطا در دریافت اطلاعات");
  };

  const bulkCancelOrderRequest = useRequest(
    () => manualBulkOrderCancel(selectedRowsIds),
    onError
  );
  // const bulkPauseOrderRequest = useRequest(
  //   () => bulkPauseStepOrder(selectedRowIds),
  //   onError
  // );
  // const bulkResumeOrderRequest = useRequest(
  //   () => bulkResumeStepOrder(selectedRowIds),
  //   onError
  // );

  useEffect(() => {
    if (bulkCancelOrderRequest.response) onAction();
  }, [bulkCancelOrderRequest.response]);

  const bulkCancelOrderHandler = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    if (!selectedRowsIds.length) return;
    bulkCancelOrderRequest.fetchData();
    setSelectedRowsIds([]);
  };

  // const bulkPauseOrderHandler = (e: React.MouseEvent<HTMLDivElement>) => {
  //   e.stopPropagation();
  //   if (!selectedRowIds.length) return;
  //   bulkPauseOrderRequest.fetchData();
  // };

  // useEffect(() => {
  //   if (bulkPauseOrderRequest.response) {
  //     toast.success(bulkPauseOrderRequest.response.msg);
  //     onAction();
  //   }
  // }, [bulkPauseOrderRequest.response]);

  // const bulkPlayOrderHandler = (e: React.MouseEvent<HTMLDivElement>) => {
  //   e.stopPropagation();
  //   if (!selectedRowIds.length) return;
  //   bulkResumeOrderRequest.fetchData();
  // };

  // useEffect(() => {
  //   if (bulkResumeOrderRequest.response)
  //     if (bulkResumeOrderRequest.response.msg) {
  //       toast.success(bulkResumeOrderRequest.response.msg);
  //       onAction();
  //     }
  // }, [bulkResumeOrderRequest.response]);
  useEffect(() => {
    if (bulkCancelOrderRequest.response)
      if (bulkCancelOrderRequest.response.msg) {
        toast.success(bulkCancelOrderRequest.response.msg);
        onAction();
      }
  }, [bulkCancelOrderRequest.response]);

  return (
    <>
      {/* <TableCell></TableCell> */}
      {/* <TableCell>
        <div className="flex flex-row">
          <div
            onClick={bulkPauseOrderHandler}
            className="hover:bg-slate-200 transition-all rounded p-1"
          >
            <PauseIcon
              className={`text-sky-900 cursor-pointer  ${
                selectedRowIds.length ? "text-sky-900 " : "text-gray-300"
              } transition-all`}
            />
          </div>
          <div
            onClick={bulkPlayOrderHandler}
            className="hover:bg-slate-200 transition-all rounded p-1"
          >
            <PlayCircleIcon
              className={`text-sky-900 cursor-pointer ${
                selectedRowIds.length ? "text-sky-900 " : "text-gray-300"
              } transition-all`}
            />
          </div>
        </div>
      </TableCell> */}
      {/* <TableCell></TableCell> */}
      {/* <TableCell></TableCell> */}
      <TableCell></TableCell>
      <TableCell></TableCell>
      <TableCell></TableCell>
      <TableCell></TableCell>
      <TableCell>
        <div
          className="hover:bg-red-100 transition-all rounded p-1"
          onClick={selectedRowsIds.length ? bulkCancelOrderHandler : undefined}
        >
          <DeleteIcon
            fontSize="small"
            className={`cursor-pointer ${
              selectedRowsIds.length ? "text-red-900 " : "text-gray-300"
            } transition-all`}
          />
        </div>
      </TableCell>
    </>
  );
};

const ManualOrderTableAdditionalCol: React.FC<{
  row: IManualOrderTableReport;
  onAction: () => void;
}> = ({ row, onAction }) => {
  const [isChancesOpen, setIsChancesOpen] = useState(false);
  const [isSahraOrderTableOpen, setIsSahraOrderTableOpen] = useState(false);
  const [isGraphModalOpen, setIsGraphModalOpen] = useState(false);
  const [isBrokerOrdersModalOpen, setIsBrokerOrdersModalOpen] = useState(false);
  const [isActionsTableModalOpen, setIsActionsTableModalOpen] = useState(false);
  const dispatch = useAppDispatch();
  // const orderGraphRequest = useRequest(
  //   () => getStepGraph(JSON.parse(row.getGraphStr)),
  //   errorHandler
  // );

  function errorHandler(e: any) {
    let error: any;

    if (!e) error = "خطا در ارتباط با سرور";
    if (e.msg) error = e.msg;
    if (e?.response?.data?.value) error = e.response.data.value;
    toast.error(error);
  }

  const btnClickHandler = () => {
    setIsChancesOpen(true);
  };

  const cancelOrderHandler = (
    e: React.MouseEvent<HTMLDivElement, MouseEvent>
  ) => {
    e.stopPropagation();
    cancelManualOrder(row.id)
      .then((resp) => {
        toast.success(resp.msg);
        onAction();
      })
      .catch((e) => errorHandler(e));
  };

  // const refreshOrderClickHandler = (e: React.MouseEvent) => {
  //   e.stopPropagation();
  //   refreshStepOrder(row.userId)
  //     .then((resp) => {
  //       toast.success(resp.msg);
  //       onAction();
  //     })
  //     .catch((e) => errorHandler(e));
  // };

  // const pauseOrderHandler = (e: React.MouseEvent) => {
  //   e.stopPropagation();
  //   pauseStepOrder(row.id)
  //     .then((resp) => {
  //       toast.success(resp.msg);
  //       onAction();
  //     })
  //     .catch((e) => errorHandler(e));
  // };

  // const playOrderHandler = (e: React.MouseEvent) => {
  //   e.stopPropagation();
  //   resumeStepOrder(row.id)
  //     .then((resp) => {
  //       toast.success(resp.msg);
  //       onAction();
  //     })
  //     .catch((e) => errorHandler(e));
  // };

  // const getOrderGraphHandler = () => {
  //   orderGraphRequest.fetchData();
  // };
  // useEffect(() => {
  //   if (!orderGraphRequest.response) return;
  //   setIsGraphModalOpen(true);
  // }, [orderGraphRequest.response]);

  // const getGraphModalUI = () => {
  //   if (!orderGraphRequest.response) return null;
  //   return (
  //     <div className="chart-fill-modal">
  //       <WrappedTimeSeriesChart dataset={orderGraphRequest.response} className="h-full w-full" />
  //     </div>
  //   );
  // };

  const editHandler = (e: React.MouseEvent) => {
    e.stopPropagation();
    dispatch(setManualEditRowValues(row));
  };

  return (
    <>
      {/* <TableCell>
        <div className="hover:bg-slate-300 transition-all rounded p-1">
          <RefreshIcon
            fontSize="small"
            onClick={refreshOrderClickHandler}
            className={`text-sky-800 cursor-pointer`}
          />
        </div>
      </TableCell>
      <TableCell>
        {row.isActive ? (
          <div className="hover:bg-slate-300 transition-all rounded p-1">
            <PauseIcon
              className="text-sky-700 cursor-pointer"
              onClick={pauseOrderHandler}
            />
          </div>
        ) : null}
        {row.isActive === false ? (
          <div className="hover:bg-slate-300 transition-all rounded p-1">
            <PlayCircleIcon
              className="text-sky-700 cursor-pointer"
              onClick={playOrderHandler}
            />
          </div>
        ) : null}
      </TableCell> */}
      <TableCell>
        <div
          className="hover:bg-slate-300 transition-all rounded p-1"
          onClick={editHandler}
        >
          <EditIcon className="text-sky-700 cursor-pointer" />
        </div>
      </TableCell>
      <TableCell>
        {isActionsTableModalOpen ? (
          <Modal title="عملیات"
            UI={
              <ActionsTable
                searchParams={
                  {
                    manualStepOrderId: row.id,
                    manualOrderId: null,
                  } as IManualActionsTableSearchParam
                }
              />
            }
            onClose={() => setIsActionsTableModalOpen(false)}
          />
        ) : null}
        <Button
          onClick={() => setIsActionsTableModalOpen(true)}
          text="عملیات"
          variant="contained"
          className="table-btn"
        />
      </TableCell>
      <TableCell>
        {isBrokerOrdersModalOpen ? (
          <Modal title="سفارشات"
            UI={
              <SahraOrderTable
                getData={getManualSahraOrderTable}
                searchParam={{ manualStepOrderId: row.id }}
              />
            }
            onClose={() => setIsBrokerOrdersModalOpen(false)}
          />
        ) : null}
        <Button
          onClick={() => setIsBrokerOrdersModalOpen(true)}
          text="سفارشات"
          variant="contained"
          className="table-btn"
        />
      </TableCell>
      <TableCell>
        {isSahraOrderTableOpen ? (
          <Modal title="جزئیات"
            UI={<SubOrdersTable manualStepOrderId={row.id} />}
            onClose={() => setIsSahraOrderTableOpen(false)}
          />
        ) : null}
        <Button
          onClick={() => setIsSahraOrderTableOpen(true)}
          text="جزئیات"
          variant="contained"
          className="table-btn"
        />
      </TableCell>
      {/* <TableCell>
        {isChancesOpen ? (
          <Modal title="شانس‌ها"
            UI={
              <HuntStrategyChancesTable
                getData={(_, offset, pageSize) =>
                  getStepShekarChanceTable(
                    { stepOrderId: row.id },
                    offset,
                    pageSize
                  )
                }
              />
            }
            onClose={() => setIsChancesOpen(false)}
          />
        ) : null}
        {row.orderStartegy === OrderStrategy.Hunt ? (
          <Button
            onClick={btnClickHandler}
            text="شانس ها"
            variant="contained"
            className="table-btn"
          />
        ) : null}
      </TableCell> */}
      {/* <TableCell>
        {isGraphModalOpen ? (
          <Modal title="نمودار"
            onClose={() => setIsGraphModalOpen(false)}
            UI={getGraphModalUI()}
            fullScreen
          />
        ) : null}
        <Button
          onClick={getOrderGraphHandler}
          text={<TimelineIcon className="!text-base" />}
          variant="contained"
          className="table-btn"
        />
      </TableCell> */}
      <TableCell>
        {row.orderStatus !== OrderStatus.Cancelled ? (
          <div
            onClick={cancelOrderHandler}
            className="hover:bg-red-100 transition-all rounded p-1"
          >
            <DeleteIcon
              fontSize="small"
              className="text-red-700 cursor-pointer"
            />
          </div>
        ) : null}
      </TableCell>
    </>
  );
};

export const ManualOrderTableAdditional: IAdditional<IManualOrderTableReport> =
  {
    getHeader: ManualOrderTableAdditionalHeader,
    getRow: ManualOrderTableAdditionalCol,
  };
